import React from 'react';
import { motion } from 'framer-motion';
import ImageSlider from './ImageSlider';

const CLIENTS = [
  { name: 'CMRL',          sub: 'Chennai Metro Rail Ltd' },
  { name: 'L&T',           sub: 'Larsen & Toubro Group' },
  { name: 'AFCONS',        sub: 'Infrastructure Ltd' },
  { name: 'MUMBAI METRO',  sub: 'Mumbai Metro Rail' },
  { name: 'BMRCL',         sub: 'Bangalore Metro Rail' },
  { name: 'CEMINDIA',      sub: 'ITD Cementation' },
  { name: 'TATA PROJECTS', sub: 'Tata Projects Limited' },
  { name: 'URC',           sub: 'URC Constructions' },
  { name: 'JOHNSON LIFTS', sub: 'Johnson Lifts Pvt Ltd' },
  { name: 'MAGNA',         sub: 'Cosma Magna International' },
];

export default function Clients() {
  const doubled = [...CLIENTS, ...CLIENTS];

  return (
    <section id="clients" className="section-pad bg-white relative overflow-hidden">
      <div className="container-xl relative z-10 text-center mb-14">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="section-label justify-center"
        >
          <span className="w-8 h-px bg-brand-orange" /> Our Experience
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="font-heading font-black text-4xl sm:text-5xl text-brand-heading mb-5 leading-tight"
        >
          TRUSTED BY <span className="text-gradient">PROJECT LEADERS</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
          className="text-brand-subtle max-w-xl mx-auto"
        >
          Supporting Metro Rail, EPC Construction, Industrial Manufacturing, Material Handling, Power & Utilities across India.
        </motion.p>
      </div>

      {/* Infinite slider */}
      <div className="relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div className="flex animate-infinite-scroll gap-4 w-max">
          {doubled.map((client, i) => (
            <div
              key={i}
              className="card card-hover rounded-2xl px-7 py-5 min-w-[180px] text-center group cursor-default"
            >
              <div className="font-heading font-black text-lg text-brand-subtle group-hover:text-brand-orange transition-colors duration-300 whitespace-nowrap">
                {client.name}
              </div>
              <div className="text-brand-subtle/60 text-[10px] tracking-wide mt-1 whitespace-nowrap">{client.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Stats row */}
      <motion.div
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.3 }}
        className="container-xl mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4"
      >
        {[
          { num: '10+', label: 'Major Clients' },
          { num: '5+',  label: 'Industry Sectors' },
          { num: 'PAN', label: 'India Coverage' },
          { num: '15+', label: 'Years Trusted' },
        ].map(s => (
          <div key={s.label} className="surface rounded-xl p-5 text-center">
            <div className="font-heading font-black text-2xl text-gradient">{s.num}</div>
            <div className="text-brand-subtle text-xs tracking-[1.5px] uppercase mt-1">{s.label}</div>
          </div>
        ))}
      </motion.div>

      <div className="container-xl mt-12">
        <ImageSlider page="clients" />
      </div>
    </section>
  );
}
